{
  "version": 1,
  "asset_id": "424a02cd-3710-48a0-a93b-7b63c6be211b",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/424a02cd-3710-48a0-a93b-7b63c6be211b/svc-aeo-geo-1200.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/424a02cd-3710-48a0-a93b-7b63c6be211b/svc-aeo-geo-1200.avif",
  "original_filename": "svc-aeo-geo-1200.avif",
  "size": 6656,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:38Z"
}
